/** Maximum CSV file size for bulk label value upload (1 MiB). */
export const MAX_CSV_FILE_SIZE_BYTES = 1024 * 1024;

const CSV_UPLOAD_MIME_TYPES = new Set([
	'text/csv',
	'application/csv',
	'text/comma-separated-values'
]);

/** True if the file is a CSV by extension or by a known CSV MIME type (edge cases where the picker is bypassed). */
export const isAcceptableCsvUploadFile = (file: File): boolean => {
	if (file.name.toLowerCase().endsWith('.csv')) {
		return true;
	}
	const mime = file.type.toLowerCase();
	return mime !== '' && CSV_UPLOAD_MIME_TYPES.has(mime);
};
